// @mui material components
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';

// @mui icons
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import ProfileInfoCard from 'examples/Cards/InfoCards/ProfileInfoCard';
import ProfilesList from 'examples/Lists/ProfilesList';
import DefaultProjectCard from 'examples/Cards/ProjectCards/DefaultProjectCard';

// Overview page components
import Header from 'layouts/profile/components/Header';
import PlatformSettings from 'layouts/profile/components/PlatformSettings';

// Data
import profilesListData from 'layouts/profile/data/profilesListData';

// Images
import homeDecor1 from 'assets/images/home-decor-1.jpg';
import homeDecor2 from 'assets/images/home-decor-2.jpg';
import homeDecor3 from 'assets/images/home-decor-3.jpg';
import homeDecor4 from 'assets/images/home-decor-4.jpeg';
import team1 from 'assets/images/team-1.jpg';
import team2 from 'assets/images/team-2.jpg';
import team3 from 'assets/images/team-3.jpg';
import team4 from 'assets/images/team-4.jpg';

// Redux Toolkit
import {useSelector} from 'react-redux';
import {CircularProgress} from '@mui/material';

function Overview() {
  const {user, loading} = useSelector(state => state.auth);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      {loading ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          mb={6}
          height="100vh">
          <CircularProgress size="3rem" color="inherit" />
        </Grid>
      ) : (
        <Header user={user}>
          <MDBox mt={5} mb={3}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} xl={4} sx={{display: 'flex'}}>
                <Divider orientation="vertical" sx={{ml: -2, mr: 1}} />
                <ProfileInfoCard
                  title="profile information"
                  description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
                  info={{
                    fullName: user?.name
                      ? user?.name
                      : `${user?.firstName} ${user?.lastName}`,
                    email: user?.email,
                    role: user?.roleDetails?.name || '—',
                    timeZone: user?.timeZone ?? null,
                  }}
                  isEditable={false}
                  social={[]}
                  shadow={false}
                />
                <Divider orientation="vertical" sx={{mx: 0}} />
              </Grid>
            </Grid>
          </MDBox>
        </Header>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
